import { render, staticRenderFns } from "./PermissionTable.vue?vue&type=template&id=845199d0&scoped=true"
import script from "./PermissionTable.vue?vue&type=script&lang=js"
export * from "./PermissionTable.vue?vue&type=script&lang=js"
import style0 from "./PermissionTable.vue?vue&type=style&index=0&id=845199d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845199d0",
  null
  
)

export default component.exports